import { useTranslate } from "@pankod/refine-core";

import {
  Edit,
  Drawer,
  DrawerProps,
  // DatePicker,
  Form,
  FormProps,
  Input,
  InputNumber,
  Radio,
  Select,
  SelectProps,
  // Space,
  ButtonProps,
  // Avatar,
  // Typography,
  // Upload,
    Grid,
  // getValueFromEvent,
  // useSelect,
} from "@pankod/refine-antd";

// import { IOrganization } from "interfaces";
// import { SelectRoomStatus } from "../roomStatus";
// import { SelectRoomLocation } from "../roomLocation";

// const { Text } = Typography;
const { TextArea } = Input;

type EditRoomProps = {
  drawerProps: DrawerProps;
  formProps: FormProps;
  saveButtonProps: ButtonProps;
};

export const EditRoom: React.FC<EditRoomProps> = ({
  drawerProps,
  formProps,
  saveButtonProps,
}) => {
  const t = useTranslate();
  const breakpoint = Grid.useBreakpoint();

  const selectLocation: SelectProps['options'] = [
		{ value: "facade", label: t("enum.roomLocation.facade") },
		{ value: "minusOne", label: t("enum.roomLocation.minusOne") },
		{ value: "zero", label: t("enum.roomLocation.zero") },
		{ value: "one", label: t("enum.roomLocation.one") },
		{ value: "two", label: t("enum.roomLocation.two") },
		{ value: "three", label: t("enum.roomLocation.three") },
		{ value: "parking", label: t("enum.roomLocation.parking") },
  ];
  const selectStatus: SelectProps['options'] = [
    { value: "free", label: t("enum.roomStatus.free") },
    { value: "busy", label: t("enum.roomStatus.busy") },
    { value: "soom", label: t("enum.roomStatus.soom") },
    { value: "reserved", label: t("enum.roomStatus.reserved") },
    { value: "maintenance", label: t("enum.roomStatus.maintenance") },
    { value: "closed", label: t("enum.roomStatus.closed") },
  ];

  // const rentStart = 
  return (
    <Drawer
      {...drawerProps}
      width={breakpoint.sm ? "500px" : "100%"}
      bodyStyle={{ padding: 0 }}
      zIndex={1001}
      // closable={false}
    >
    {/* <Edit resource="profilea" saveButtonProps={saveButtonProps}> */}
      <Edit saveButtonProps={saveButtonProps}>
        <Form
          {...formProps}
          layout="vertical"
          // initialValues={{
          //   rent_start: null,
          //   isActive: true,
          //   status: "free",
          //   price: 0,
          //   price_area: 0
          // }}
        >
          <Form.Item
            label={t("rooms.fields.title")}
            name="title"
            rules={[{ required: true }]}
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t("rooms.fields.code")}
            name="code"
            rules={[{ required: true }]}
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label={t("rooms.fields.price")}
            name="price"
            rules={[{ type: 'number' }]}
            style={{ display: 'inline-block', width: 'calc(33% - 8px)' }}
          >
            <InputNumber 
              formatter={(value) => `${value} ₴`}
              // style={{ width: "150px" }}
            />
          </Form.Item>
          <Form.Item
            label={t("rooms.fields.area")}
            name="area"
            rules={[{ required: true, type: 'number' }]}
            style={{ display: 'inline-block', width: 'calc(33% - 8px)' }}
          >
            <InputNumber />
          </Form.Item>
          <Form.Item
            label={t("rooms.fields.priceArea")}
            name="price_area"
            rules={[{ type: 'number' }]}
            style={{ display: 'inline-block', width: 'calc(33% - 8px)' }}
          >
            <InputNumber
              formatter={(value) => `${value} ₴`}
              defaultValue={0}
              // style={{ width: "150px" }}
            />
          </Form.Item>
          <Form.Item
            label={t("rooms.fields.location")}
            name="location"
            rules={[{ required: true }]}
          >
            <Select options={selectLocation} />
          </Form.Item>
          <Form.Item
            label={t("rooms.fields.status")}
            name="status"
          >
            <Select options={selectStatus} />
          </Form.Item>
          {/* <Form.Item
            label={t("rooms.fields.rentStart")}
            name="rent_start"
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
          >
            <DatePicker />
          </Form.Item> */}
          {/* <Form.Item
            label={t("rooms.fields.rentEnd")}
            name="rent_end"
            style={{ display: 'inline-block', width: 'calc(50% - 8px)' }}
          >
            <DatePicker />
          </Form.Item> */}
          <Form.Item label={t("rooms.fields.isActive")} name="isActive">
            <Radio.Group>
              <Radio value={true}>{t("status.enable")}</Radio>
              <Radio value={false}>{t("status.disable")}</Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item
            label={t("rooms.fields.description")}
            name="description"
          >
            <TextArea rows={4} />
          </Form.Item>
        </Form>
      </Edit>
    </Drawer>
  );
};
